import React, { useState } from "react";
import Modal from "../Modal";

const TeamSettingsModal = ({ isOpen, onClose, team, onSave }) => {
    const [teamName, setTeamName] = useState(team?.name || "");
    const [inviteLinkEnabled, setInviteLinkEnabled] = useState(
        typeof team?.inviteLinkEnabled === 'boolean' ? team.inviteLinkEnabled : true
    );
    const [urlKey, setUrlKey] = useState(team?.url_key || "");

    React.useEffect(() => {
        setTeamName(team?.name || "");
        setInviteLinkEnabled(typeof team?.inviteLinkEnabled === 'boolean' ? team.inviteLinkEnabled : true);
        setUrlKey(team?.url_key || "");
    }, [team]);

    const handleSave = (e) => {
        e.preventDefault();
        if (teamName.trim()) {
            onSave({ ...team, name: teamName.trim(), inviteLinkEnabled, url_key: urlKey });
        }
    };

    // Simple random key generator (xxxxx-xxxxx-xxxxx)
    const generateNewUrlKey = () => {
        const rand = () => Math.random().toString(36).substring(2, 7);
        setUrlKey(`${rand()}-${rand()}-${rand()}`);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <h2 className="text-lg font-semibold mb-4 dark:text-white">Team Settings</h2>
            <form onSubmit={handleSave} className="flex flex-col gap-4">
                <div>
                    <label className="block text-sm font-medium mb-1 dark:text-white">Team Name</label>
                    <input
                        type="text"
                        className="w-full border border-gray-300 dark:border-gray-700 rounded px-3 py-2 bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400"
                        placeholder="Enter team name"
                        value={teamName}
                        onChange={e => setTeamName(e.target.value)}
                        required
                    />
                </div>
                <div className="mt-2">
                    <label className="flex items-center gap-3 text-sm font-medium mb-1 dark:text-white select-none">
                    <button
                        type="button"
                        role="switch"
                        aria-checked={inviteLinkEnabled}
                        tabIndex={0}
                        onClick={() => setInviteLinkEnabled(v => !v)}
                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') setInviteLinkEnabled(v => !v); }}
                        className={`relative flex items-center h-8 w-14 rounded-full transition-colors duration-300 focus:outline-none ${inviteLinkEnabled ? 'bg-gradient-to-r from-sky-500 to-sky-600' : 'bg-gray-300 dark:bg-gray-700'}`}
                        style={{ minWidth: '3.5rem' }}
                    >
                        <span
                            className={`absolute left-1 top-1 transition-transform duration-300 h-6 w-6 rounded-full bg-white dark:bg-gray-100 shadow ${inviteLinkEnabled ? 'translate-x-6' : 'translate-x-0'}`}
                            aria-hidden="true"
                            style={{ willChange: 'transform' }}
                        />
                        <span className="sr-only">Toggle Invite Link</span>
                    </button>
                    <span>Enable Invite Link</span>
                </label>
                    <p className="text-xs text-gray-500 dark:text-gray-400">If disabled, the invite link and 'Invite Members' button will be hidden/disabled for this team.</p>
                </div>
                {inviteLinkEnabled && (
                    <div>
                        <label className="block text-sm font-medium mb-1 dark:text-white">Invite Link Key</label>
                        <div className="flex gap-2 items-center">
                            <input
                                type="text"
                                className="w-full border border-gray-300 dark:border-gray-700 rounded px-3 py-2 bg-gray-100 dark:bg-gray-900 text-gray-700 dark:text-gray-200 focus:outline-none"
                                value={urlKey}
                                readOnly
                            />
                            <button
                                type="button"
                                className="h-10 px-3 rounded bg-gradient-to-r from-sky-500 to-sky-600 text-white font-semibold shadow hover:from-sky-600 hover:to-sky-700 transition whitespace-nowrap"
                                style={{ minWidth: 'auto', paddingTop: '0.5rem', paddingBottom: '0.5rem' }}
                                onClick={generateNewUrlKey}
                            >
                                Generate New
                            </button>
                        </div>
                        <p className="text-xs text-gray-500 dark:text-gray-400 ml-1 mt-1">Share this key as part of your invite link. Generating a new link will invalidate the previous one.</p>
                    </div>
                )}
                <div className="flex gap-2 justify-end">
                    <button
                        type="button"
                        className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="bg-gradient-to-r from-sky-500 to-sky-600 hover:from-sky-600 hover:to-sky-700 text-white font-bold py-2 px-6 rounded shadow transition"
                    >
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default TeamSettingsModal;
